import { BRAND } from "@/lib/assets";

export default function IntegratedStrength() {
  return (
    <section id="strength" data-testid="integrated-strength-section" className="relative bg-navy-dark text-white py-24 md:py-32 overflow-hidden">
      {/* Watermark logo */}
      <div className="pointer-events-none absolute -right-32 top-1/2 -translate-y-1/2 opacity-[0.06]" aria-hidden="true">
        <img src={BRAND.logo} alt=""
             className="w-[900px] max-w-none brightness-0 invert" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">03 — Integrated Strength</span>
          </div>
          <h2 className="font-serif text-white text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
            One <em className="text-gold not-italic">professional identity.</em> Many capabilities.
          </h2>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <p className="text-white/75 text-lg md:text-xl leading-relaxed font-light">
            The strength of Salihi Group lies in its integrated structure. Legal, consulting, technical, investment, natural resources, and employment services sit under one professional corporate identity — so clients can access multiple services without managing multiple vendor relationships.
          </p>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mt-6 font-light">
            An investor entering through one company can draw on legal support, business advisory, engineering input, recruitment services, and investment structuring from the rest of the Group as their needs grow.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6">
            {[
              { n: "7", l: "Specialized companies" },
              { n: "1", l: "Professional identity" },
              { n: "10+", l: "Sectors served" },
            ].map((item) => (
              <div key={item.l} className="border-l border-gold/40 pl-4">
                <div className="font-serif text-3xl md:text-4xl text-gold font-light">{item.n}</div>
                <div className="text-white/60 text-xs uppercase tracking-[0.16em] mt-2">{item.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
